import { ILifeRule } from "./ILifeRule";

export class LiveCellWithFewerThanTwoNeighborsRule implements ILifeRule {
  canHandle = (isAlive: boolean): boolean => isAlive === true;

  shouldLive(numberOfNeighbors: number): boolean {
    return numberOfNeighbors >= 2;
  }
}
